module.exports = __webpack_public_path__ + "1304c295b526502a0631d622e2bfd764.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iyv-logo-project-of-2021.jpg
// module id = 1970
// module chunks = 0